<template>
  <div class="cus-chat-supervise">
    <div class="cus-chat-supervise-search">
      <el-select v-model="formInline.bindStatus" placeholder="请选择" size="mini" @change="selectBindStatus"
        style="width: 150px">
        <el-option v-for="item in options" :key="item.bindStatus" :label="item.label" :value="item.bindStatus">
        </el-option>
      </el-select>
      <div style="width:250px;display:inline-block;margin-left:12px">
        <el-input size="mini" v-model="formInline.queryCustomerChat" placeholder="档案名/卡号/昵称/备注名" @blur="onInputBlur"
          @clear="onInputBlur" clearable>
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table size="small" :data="tableData" fit highlight-current-row align="center"
          :header-cell-style="{ background: '#F9F9F9' }" :height="tableHeight" ref='cusChatTable' style="font-size: 13px">
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <!-- <el-table-column prop="rowNumb" label="NO." width="70px"/> -->
          <el-table-column prop="name" label="客户" min-width="150px">
            <template slot-scope="scope">
              {{ scope.row.name }}<span style="color: rgb(70, 189, 10)" v-if="scope.row.type == 1"> @微信</span><span
                style="color: rgb(8, 168, 231)" v-else> @{{ scope.row.corpName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="employee" label="档案名">
            <template slot-scope="scope">
              <span v-if="scope.row.ctmName != null">{{ scope.row.ctmName }}</span>
              <span v-else style="color: rgb(228, 96, 63)">未绑定</span>
            </template>
          </el-table-column>
          <el-table-column prop="ctmCode" label="卡号">
          </el-table-column>

          <!-- <el-table-column prop="remark" label="备注名" /> -->
          <el-table-column prop="chargePerson" label="跟进员工">
            <template slot-scope="scope">
              <span style="color: #FFAA33" v-if="scope.row.chargePerson == null">无跟进员工</span>
              <span v-else>{{ scope.row.chargePerson }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="recentTime" label="上次聊天">
            <template slot-scope="scope">
              <span style="color: #FFAA33" v-if="scope.row.recentTime == null">无上次聊天时间</span>
              <span v-else>{{ scope.row.recentTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作">
            <template slot-scope="scope">
              <el-link style="font-size:13px;" :underline="false" type="primary" icon="el-icon-view"
                @click.native="viewContent(scope.$index, scope.row)">聊天内容</el-link>
              <!-- <el-link v-else style="font-size:13px;" :underline="false" type="primary" icon="el-icon-view"
                @click.native="test(scope.$index, scope.row)">聊天内容</el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack"></Pagination>
    <el-dialog :title="chatTitle" :visible.sync="dialogVisible" :close-on-click-modal='false' width="70%" :center='true'
      :close-on-press-escape='true' @close="close">
      <div style="">
        <ChatContentDia :idData="uid" v-if="newChatDialogVisible" />
        <!-- <CusChatView :idData="uid" v-if="environment === 'other' || !isNewEdition" /> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getChatQwAndYuanNeiCUstomer, getCustomerList } from '@/api/customer/customer.js'
import { getSessionVersion } from "@/api/staff/staff.js";
import CusChatView from '../chat/components/CusChatView'
// import ChatContentDia from './components/ChatContentDia'
import ChatContentDia from './components/newChat/ChatContentDia.vue'
export default {
  name: 'CusChatSupervise',
  components: {
    CusChatView,
    ChatContentDia
  },
  data() {
    return {
      tableData: [
      ],
      tableHeight: 500,
      dialogVisible: false,
      // loading: true,
      uid: '',
      chatTitle: '',
      options: [
        {
          bindStatus: 10,
          label: '不限'
        }, {
          bindStatus: 1,
          label: '已绑定档案'
        }, {
          bindStatus: 0,
          label: '未绑定档案'
        }
      ],
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      formInline: {
        currentPage: 1,
        pageSize: 20,
        bindStatus: 10,
        //name: '',
        dateCustomerChat: [],
        queryCustomerChat: '',
      },
      pageSizes: [20, 50, 100, 200, 500],//分页条数
      /** 是否新版本会话 */
      // isNewEdition: true,
      /** 控制新版聊天记录弹窗显示隐藏 */
      newChatDialogVisible: false,
      /** 当前所属环境 com-wx-mobile手机端企业微 com-wx-pc电脑端企微 other其他环境（外部浏览器）*/
      // environment: "",
      // 提示实例，防止弹出多个提示
      messageInstance: null
    }
  },
  async created() {
    // 获取当前环境
    // this.environment = window.localStorage.getItem("environment") || await this.getEnvironment()
    // console.log("this.environment+++", this.environment);
    /** 获取判断新旧版本参数 */
    // await this.getVersionsParams()
    this.getChatQwAndYuanNeiCUstomerData(this.formInline);

  },
  methods: {
    selectBindStatus(value) {
      // this.loading = true
      this.formInline.currentPage = 1
      this.getChatQwAndYuanNeiCUstomerData(this.formInline)
    },
    selectTime() {
      // this.loading = true
      this.formInline.currentPage = 1
      this.getChatQwAndYuanNeiCUstomerData(this.formInline)
    },
    onInputBlur() {
      // this.loading = true
      this.formInline.currentPage = 1
      this.getChatQwAndYuanNeiCUstomerData(this.formInline)
    },
    getChatQwAndYuanNeiCUstomerData(parameter) {

      // if (this.isNewEdition && this.environment !== 'other') {
        /** 新版走这里 */
        getCustomerList(parameter,
          localStorage.getItem("Authorization")).then((res) => {
            if (res && res.error && res.error.code == 200) {
              this.tableData = res.data.result;
              this.pageparm.total = res.data.totals
              this.pageparm.currentPage = this.formInline.currentPage
              this.pageparm.pageSize = this.formInline.pageSize
            } else {
              if (this.messageInstance) this.messageInstance.close()
              this.messageInstance = this.$message.error("获取失败，请稍后再试")
            }
          }).catch((err) => {
            if (this.messageInstance) this.messageInstance.close()
            this.messageInstance = this.$message.error("获取失败，请稍后再试")
            console.log(err, "errr");
          })
      // } else {
      //   /** 旧版 */
      //   getChatQwAndYuanNeiCUstomer(parameter, localStorage.getItem("Authorization")).then(res => {
      //     if (res.error.code == 200) {
      //       this.tableData = res.data.result;
      //       this.pageparm.total = res.data.totals
      //       this.pageparm.currentPage = this.formInline.currentPage
      //       this.pageparm.pageSize = this.formInline.pageSize
      //     }
      //   })
      // }
    },

    search() {
      // this.loading = true;
      this.formInline.currentPage = 1;
      this.getChatQwAndYuanNeiCUstomerData(this.formInline)
    },

    clear() {
      this.formInline.name = '';
    },

    test(index, row) {
      //alert("你好")
      // console.log("faffff")
      //console.log(row);
      this.uid = row.externalUserId;
      // console.log(this.uid);
      this.dialogVisible = true;
      this.chatTitle = row.name + '的聊天内容'
    },

    /** 查看聊天内容 */
    viewContent(index, row) {
      this.uid = row.externalUserId;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.newChatDialogVisible = true;
      })
      this.chatTitle = row.name + '的聊天内容'
    },

    controlHeight() {
      this.$nextTick(function () {
        this.tableHeight = window.innerHeight - this.$refs.cusChatTable.$el.offsetTop - 236

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          self.tableHeight = window.innerHeight - self.$refs.cusChatTable.$el.offsetTop - 236
        }
      })
    },
    callBack(parm) {
      this.formInline.currentPage = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      // this.loading = true;
      this.getChatQwAndYuanNeiCUstomerData(this.formInline)
    },

    /** 获取判断新旧版本参数 */
    // async getVersionsParams() {
    //   await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
    //     if (res && res.error && res.error.code === 200) {
    //       this.isNewEdition = res.data
    //       window.localStorage.setItem("isNewEdition", this.isNewEdition);
    //     } else {
    //       this.$message.error("获取版本参数失败")
    //     }
    //   }).catch((err) => {
    //     this.$message.error("获取版本参数失败")
    //     console.log("新旧版本参数获取失败", err);
    //   });
    // },
    /** 弹窗关闭 */
    close() {
      console.log("弹窗关闭");
      this.dialogVisible = false;
      this.newChatDialogVisible = false;
    },

    /** 获取当前环境 */
    // getEnvironment() {
    //   let isMobile = window.navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   ); // 是否手机端
    //   let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
    //   if (isComWx && isMobile) {
    //     //手机端企业微信
    //     this.environment = "com-wx-mobile";
    //   } else if (isComWx && !isMobile) {
    //     //PC端企业微信
    //     this.environment = "com-wx-pc";
    //   } else {
    //     //其他环境
    //     this.environment = "other";
    //   }
    //   window.localStorage.setItem("environment", this.environment);
    // },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['cusChatTable'].doLayout();
    })

  },
  mounted: function () {
    this.controlHeight();
  },
}
</script>
<style lang="scss">
.cus-chat-supervise {
  .cus-chat-supervise-search {
    margin-bottom: 10px
  }

  .el-dialog {
    min-width: 620px;
    max-width: 1200px;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #0f0f0f;
  }

  .el-dialog__body {
    padding: 5px 30px 20px !important;
  }
}
</style>